/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Genderpreference_No_Preference13Inputs */

const en__field__enum_genderpreference_no_preference13 = /** @type {(inputs: _Field__Enum_Genderpreference_No_Preference13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No preference`)
};

const de__field__enum_genderpreference_no_preference13 = /** @type {(inputs: _Field__Enum_Genderpreference_No_Preference13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Präferenz`)
};

/**
* | output |
* | --- |
* | "No preference" |
*
* @param {_Field__Enum_Genderpreference_No_Preference13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_genderpreference_no_preference13 = /** @type {((inputs?: _Field__Enum_Genderpreference_No_Preference13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Genderpreference_No_Preference13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_genderpreference_no_preference13(inputs)
	return de__field__enum_genderpreference_no_preference13(inputs)
});
export { _field__enum_genderpreference_no_preference13 as "_field__enum_genderPreference_NO_PREFERENCE" }